import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversation } from 'entities/Conversation/api/types'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { Message } from 'entities/Message/model/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ILocalTypeInbox } from 'entities/Inbox'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import {
  canAddConversationToList,
  type ConversationListStore,
} from 'pages/conversations/ui/ConversationList'

export const useEventConversationClosed = (
  conversationListStore: ConversationListStore,
  view: ILocalTypeInbox
) => {
  const entities = useEntitiesContext()
  const { conversationStore } = entities
  const handler = (data: IResponseConversation) => {
    const item = new Conversation(data, entities)
    const message = new Message(
      {
        message: data.recent_message,
      },
      entities
    )
    const update = () => {
      if (filtersStore.isShowConversation(item, message)) {
        updateItem(data)
        addItemOrder(data.id)

        return
      }

      deleteItemOrder(data.id)
      deleteItem(data.id)
    }

    const { deleteItem, updateItem } = conversationStore
    const { deleteItemOrder, addItemOrder, filtersStore } = conversationListStore

    runInAction(() => {
      // Smart view
      if (view === 'smart_view') {
        const smartView = entities.inboxesStore.localInboxes.currentSmartView

        if (!smartView) return
        if (!checkFilterSmartView(item.smartViewFilterParams, smartView.filters)) return

        update()

        return
      }

      // Default
      if (!canAddConversationToList(data, entities)) return
      update()
    })
  }

  useEffect(() => entities.websocket.on(WebsocketEvent.ConversationClosed, handler), [view])
}
